import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/actividades_entrega/actividades_entrega';
import CrearEditar from './CrearEditar';

const ms2p = (state) => {
  return {
    ...state.actividades_entrega,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(CrearEditar);
